import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Save, Send } from "lucide-react";

const STATUS = { sent: "Gönderildi", failed: "Başarısız", skipped: "Atlandı" };

export const EmailScheduleCard = ({ endpoint, prefix, title, description, emailLabel, sentToast, extra }) => {
  const [cfg, setCfg] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState("");
  const touched = useRef(false);

  const reload = () => api.get(endpoint).then((r) => {
    setCfg(r.data);
    if (!touched.current) setEmail(r.data.email || "");
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { reload(); }, []);

  const save = async () => {
    setBusy("save");
    try {
      const r = await api.put(endpoint, { email });
      setCfg(r.data);
      touched.current = false;
      toast.success(email ? "E-posta adresi kaydedildi" : "Otomatik gönderim kapatıldı");
    } catch (e) { toast.error(e?.response?.data?.detail?.toString?.() || "Kaydedilemedi"); }
    finally { setBusy(""); }
  };

  const sendNow = async () => {
    setBusy("send");
    try {
      const r = await api.post(`${endpoint}/send-now`);
      setCfg(r.data);
      toast.success(sentToast);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gönderilemedi");
      reload();
    } finally { setBusy(""); }
  };

  return (
    <Card className="p-6 border border-slate-200 shadow-sm max-w-2xl mt-6" data-testid={`${prefix}-card`}>
      <h3 className="font-display font-semibold text-slate-900">{title}</h3>
      <p className="text-sm text-slate-500 mt-1">{description}</p>
      {!cfg ? <div className="text-sm text-slate-500 mt-4">Yükleniyor...</div> : (
        <>
          {extra && <div className="mt-3">{extra(cfg)}</div>}
          <div className="mt-4">
            <Label>{emailLabel}</Label>
            <div className="flex flex-wrap gap-2 mt-1">
              <Input type="email" value={email} maxLength={200} placeholder="ornek@birlik.gov.tr" className="flex-1 min-w-[220px]"
                     onChange={(e) => { touched.current = true; setEmail(e.target.value); }} data-testid={`${prefix}-input`} />
              <Button onClick={save} disabled={!!busy} className="bg-emerald-700 hover:bg-emerald-800" data-testid={`${prefix}-save-button`}>
                {busy === "save" ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Save className="h-4 w-4 mr-1.5" />} Kaydet
              </Button>
            </div>
          </div>
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <Button variant="outline" onClick={sendNow} disabled={!!busy || !cfg.email} data-testid={`${prefix}-send-now-button`}>
              {busy === "send" ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Send className="h-4 w-4 mr-1.5" />} Şimdi Gönder
            </Button>
            <div className="text-xs text-slate-500" data-testid={`${prefix}-last-status`}>
              {cfg.last_at
                ? `Son çalışma: ${new Date(cfg.last_at).toLocaleString("tr-TR")} · ${cfg.last_trigger === "cron" ? "otomatik" : "elle"} · ${STATUS[cfg.last_status] || cfg.last_status}${cfg.last_error ? ` (${cfg.last_error})` : ""}`
                : "Henüz gönderim yapılmadı."}
            </div>
          </div>
        </>
      )}
    </Card>
  );
};
